<template>
	<section class="page-logout"></section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';
	import { mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks
	 */
	@Component
	export default class PageLogout extends PageBase {
		/**
		 * @return void
		 */
		@mounted
		public logout(): void {
			// Logout
			this.$store.dispatch('logout');

			// Redirect home
			location.href = '/';
		}
	}
</script>

<style lang="scss">
	.page-logout {
		// Not implemented
	}
</style>
